import Vue from 'vue'

const subscriberBus = new Vue()

export const NOTIFICATION_BUS_EVENTS = Object.freeze({
    CONNECTED: 'notify-hub:connected',
    RECONNECTING: 'notify-hub:reconnecting',
    DISCONNECTED: 'notify-hub:disconnected',

    USER_DATA: 'notify-hub:user-data',
    USER_NOTIFICATION: 'notify-hub:user-notification',

    ORDER_EVENT: 'notify-hub:order-event',
    BALANCE_EVENT: 'notify-hub:balance-event',

    NEW_NOTIFICATIONS: 'notify-hub:new-notifications',

    CREATE_WITHDRAW_FOR_ADMIN:
        'notify-hub:create-withdraw-for-admin',

    WITHDRAW_APPROVED_TO_BOOSTER:
        'notify-hub:withdraw-approved-to-booster',

    REFRESH_NOTIFICATIONS:
        'notify-hub:refresh-notifications',
})

export default subscriberBus